import { useEffect, createRef, useState } from 'react';
import { shape, bool, number, object } from 'prop-types';
import { DisplayField, DisplayLink, Heading, Info, LabelText } from 'shared/components';
import { CheckboxField, CurrencyField, TextField } from 'shared/fields';
import { InputsContainer } from 'shared/containers';
import { Errors } from 'shared/inputs';
import { currencyFormatter } from '@dnhb/formatters';
import { finalFormErrorHandler } from '@dnhb/node_package';
import axios from 'axios';
import { useForm } from 'react-final-form';
import { useNavigate } from 'react-router-dom';

const CurrentSituation = ({ values: { current_house_value_unknown, estimated_current_house_value }, submitErrors }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/hypotheekbespaarcheck/current-situation');
  }, [navigate]);

  const [calculating, setCalculating] = useState(false);
  const form = useForm();
  const getHouseValue = () => {
    setCalculating(true);
    axios({
      method: 'post',
      data: form.getState().values,
      url: '/hypotheekbespaarcheck/calculate/estimate-house-value',
    }).then(result => {
      form.mutators.setError({});
      const { estimatedHouseValue } = result.data;
      form.change('estimated_current_house_value', estimatedHouseValue)
    }).catch(error => {
      form.mutators.setError(finalFormErrorHandler(error));
    }).finally(() => {
      setCalculating(false);
    });
  }
  const postalSubmit = createRef();
  const handleEnterKey = e => {
    if (e.key === 'Enter' && !estimated_current_house_value) {
      e.preventDefault()
      postalSubmit.current.click()
    }
  }

  return (
    <>
      <Heading>Huidige situatie</Heading>
      <InputsContainer>
        <LabelText>
          Wat is nu je hypotheekschuld?
          <Info title='Wat is nu de (rest)schuld van je hypotheek?'>
            Je (rest)hyptheekschuld is het hypotheekbedrag bij de start min wat
            je al hebt afgelost (automatisch, en eventueel extra)
          </Info>
        </LabelText>
        <CurrencyField placeholder="Bedrag" name="current_mortgage_debt" />
        <LabelText>Wat is je woning nu ongeveer waard?</LabelText>
        <CurrencyField placeholder="Bedrag" name="current_house_value" disabled={current_house_value_unknown} />
        <CheckboxField id="current_house_value_unknown" name="current_house_value_unknown" label="Ik weet het niet" />
        {current_house_value_unknown && (
          <>
            <div css={{ display: 'flex', alignItems: 'flex-start' }}>
              <TextField
                placeholder="Postcode"
                name="postal_code"
                parse={val => val && val.toUpperCase().replace(' ', '')}
                maxWidth="31%"
                css={{ display: 'inline-block' }}
                onKeyPress={handleEnterKey}
              />
              <DisplayLink
                css={{ marginTop: '11px', marginLeft: '16px' }}
                disabled={calculating}
                onClick={getHouseValue}
                ref={postalSubmit}
              >
                Berekenen
              </DisplayLink>
            </div>
            <LabelText>Onze geschatte woningwaarde</LabelText>
            <DisplayField>{currencyFormatter(Math.floor(estimated_current_house_value / 500) * 500)}</DisplayField>
            <Errors errors={submitErrors && submitErrors.estimated_current_house_value} />
          </>
        )}
      </InputsContainer>
    </>
  );
}

CurrentSituation.propTypes = {
  values: shape({
    current_house_value_unknown: bool,
    estimated_current_house_value: number,
  }).isRequired,
  submitErrors: object,
};

CurrentSituation.defaultProps = {
  submitErrors: {},
};

export default CurrentSituation;
